import { motion } from "framer-motion";

const STATS = [
    { v: "AED 3.4B", k: "Capital Deployed in 2025", accent: "text-gold" },
    { v: "1,280+", k: "Active Mandates", accent: "text-coral-soft" },
    { v: "11 yrs", k: "DIFC Track Record", accent: "text-cream" },
    { v: "97%", k: "Client Retention", accent: "text-gold-soft" },
];

const BAND_IMG =
    "https://images.unsplash.com/photo-1518684079-3c830dcef090?auto=format&fit=crop&w=2000&q=80";

export default function NumbersBand() {
    return (
        <section
            data-testid="numbers-band"
            className="relative py-20 md:py-24 overflow-hidden"
        >
            <div className="absolute inset-0">
                <img
                    src={BAND_IMG}
                    alt=""
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-forest/85" />
            </div>

            <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 text-white">
                <div className="grid md:grid-cols-12 gap-8 items-end mb-10">
                    <div className="md:col-span-7">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="w-8 h-px bg-gold" />
                            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">
                                A decade · A track record
                            </span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl leading-[1] tracking-tight font-medium">
                            The receipts. Not just the<br />
                            <em className="italic text-gold font-normal">rhetoric.</em>
                        </h2>
                    </div>
                    <div className="md:col-span-4 md:col-start-9">
                        <p className="text-white/80 font-light leading-relaxed text-lg">
                            Eleven years of privately structured mandates across the Emirates. Numbers our auditors stand behind — and our clients return for.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
                    {STATS.map((s, i) => (
                        <motion.div
                            key={s.k}
                            data-testid={`band-stat-${i}`}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className="bg-forest hover:bg-forest-deep transition-colors p-7 md:p-9"
                        >
                            <div className={`font-serif text-4xl md:text-5xl ${s.accent} leading-none`}>
                                {s.v}
                            </div>
                            <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-white/70">
                                {s.k}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
